// extracted by mini-css-extract-plugin
module.exports = {"NoChartAvailable":"NoChartAvailable_-mTOY"};